const CaptureService = {
    //  DATASETS & METRICS
    generateStyleDefs: function (svgDomElement, document) {
        var styleDefs = "";
        [...document.styleSheets].forEach(function(sheet) {
            if ((sheet.href && sheet.href.indexOf(window.location.host) === -1) // css must from same origin because chrome throws a security exception
                || !(sheet.cssRules instanceof CSSRuleList)) { // and must contain CSSRuleList
                return;
            }
            [...sheet.cssRules].forEach(function(rule) {
                if (rule.style) {
                    var selectorText = rule.selectorText;
                    var elems = svgDomElement.querySelectorAll(selectorText);

                    if (elems.length) { // the connector's fill propery isn't properly taking precedence over the highcharts-color-n style so force the order
                        if (selectorText === '.highcharts-data-label-connector') {
                            styleDefs = selectorText + " { " + rule.style.cssText + " }\n" + styleDefs;
                        } else {
                            styleDefs += selectorText + " { " + rule.style.cssText + " }\n";
                        }
                    }
                }
            });
        });

        var s = document.createElement('style');
        s.setAttribute('type', 'text/css');

        s.innerHTML = styleDefs;

        var defs = document.createElement('defs');
        defs.appendChild(s);
        svgDomElement.insertBefore(defs, svgDomElement.firstChild);
        return defs;
    },
};

export default CaptureService;
